import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {scale, Color, Scale} from "chroma-js";
import {getEnergyOutput, getEnergyOutputRatio} from "../../../../../store/reducers/outputs/energyOutput";
import OutputTooltip from "./output-tooltip/OutputTooltip";
import {getEnergyDemand} from '../../../../../store/reducers/energy/energyDemand';

interface Props
{
    // target_output: number;
    energy_demand: number;
    energy_output: number;
    energy_output_ratio: number;
}

interface State
{
    hover: boolean;
}

import './EnergyOutput.scss';

const initial_state: State = { hover: false };

class EnergyOutput extends React.Component<Props, State>
{
    constructor(public props: Props, public state: State = initial_state)
    {
        super(props);
    }


    getOutputText = () : string =>
    {
        const {energy_output_ratio:pc = 0} = this.props;

        const ratio: number = pc * 100;

        if (ratio < 5) return 'not enough power';
        if (ratio < 15) return 'too low';
        if (ratio < 25) return 'ok';
        if (ratio < 35) return 'good';
        if (ratio < 45) return 'great';
        if (ratio < 55) return 'excellent';
        if (ratio < 65) return 'great';
        if (ratio < 75) return 'good';
        if (ratio < 88) return 'too much';
        if (ratio < 95) return 'wasting power';

        return 'really wasteful';
    };


    getOutputColour = () : string =>
    {
        const {energy_output_ratio:pc = 0} = this.props;

        const colour_scale: Scale = scale(
            [
                '#ff0000',
                '#fff600',
                '#25cc00',
                '#fff600',
                '#ff0000',
            ]);

        // console.log('colour_scale', colour_scale)
        // console.log('output_value', output_value)

        // console.group('getOutputColour');
        // console.log('pc', pc);
        // console.groupEnd();

        return colour_scale(pc).hex();
    };


    onMouseEnter = () =>
    {
        const {hover} = this.state;

        if (hover) return;

        this.setState({ hover: true });
    };



    onMouseLeave = () =>
    {
        const {hover} = this.state;

        if (! hover) return;

        this.setState({ hover: false });
    };



    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {energy_output, energy_demand} = this.props;
        const {hover} = this.state;

        const colour: string = this.getOutputColour();

        return <div
                    styleName={'numeric-metre'}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}>

            {/*<div styleName={'readout'}>*/}

                {/*<div styleName={'readout-label'}>*/}

                    {/*<i className="fas fa-lightbulb" />*/}

                    {/*<p styleName={'label-text'}>energy output</p>*/}

                {/*</div>*/}

                {/*/!*<div styleName={'readout-summary'} style={{ color: colour }}>*!/*/}
                    {/*/!*<p>{this.getOutputText()}</p>*!/*/}
                {/*/!*</div>*!/*/}

                {/*<div styleName={'number-values'}>*/}

                    {/*<h3 styleName={'output-number'}>{energy_output}</h3>*/}

                    {/*<p styleName={'right-hand-text'}>*/}
                        {/*<span styleName={'target-number'}>/{Math.round(energy_demand)}</span>*/}
                        {/*<span styleName={'units-text'}>MEGA WATTS</span>*/}
                    {/*</p>*/}

                {/*</div>*/}

            {/*</div>*/}


            <div styleName={'readout'}>

                <div styleName={'output-label green'} style={{ color: this.getOutputColour() }}>power output</div>

                <div styleName={'output-value green'} style={{ color: this.getOutputColour() }}>

                    {energy_output} <span styleName={'output-units'}>tera watts hrs</span>

                </div>

                <span styleName={'output-divider grey'}>/</span>

                <div styleName={'output-value grey'}>{energy_demand} <span styleName={'output-units'}>tera watts hrs</span></div>

                <div styleName={'demand-output-label'}>power needed</div>

            </div>

            <OutputTooltip
                visible={hover} title={'Energy Output'}>

                This is how much energy your power plants are producing. Try to get as close to the target as possible - too much or too little is bad!

            </OutputTooltip>

        </div>
    }
}


const mapStateToProps = state =>
{
    return {
        // target_output: getTargetEnergyOutput(),
        energy_demand: getEnergyDemand(state),
        energy_output: getEnergyOutput(state),
        energy_output_ratio: getEnergyOutputRatio(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(EnergyOutput);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/game-ui/outputs/EnergyOutput.tsx